import React from 'react';
import { ShieldIcon, LeafIcon, HeartIcon } from 'lucide-react';
import { trackFbEvent } from '../utils/fbpixel';
export function HeroSection() {
  return <section className="relative w-full flex flex-col items-center justify-start px-4 pb-3" style={{
    height: '100dvh',
    paddingTop: 'calc(env(safe-area-inset-top, 0px) + 3rem)',
    background: 'radial-gradient(ellipse at center, #2D1B69 0%, #0D0D0D 70%)'
  }} data-id="element-120">
      <div className="absolute inset-0 opacity-[0.06]" style={{
      backgroundImage: 'radial-gradient(circle at 20% 30%, #FF006E 1px, transparent 1px), radial-gradient(circle at 80% 70%, #00F5D4 1px, transparent 1px)',
      backgroundSize: '60px 60px, 80px 80px'
    }} data-id="element-121" />

      <div className="relative z-10 flex flex-col items-center text-center gap-1 max-w-lg w-full" data-id="element-122">
        {/* Badge */}
        <div className="hero-fade-1 inline-flex items-center px-3 py-0.5 rounded-full text-[11px] font-semibold" style={{
        background: 'rgba(255,0,110,0.12)',
        border: '1px solid #FF006E'
      }} data-id="element-123">
          🔬 Para mujeres con Cándida Recurrente (sin óvulos)
        </div>

        {/* Title */}
        <h1 className="hero-fade-2 text-[20px] sm:text-[28px] font-bold leading-tight text-white" data-id="element-124">
          Cándida recurrente: el ciclo que nadie te explicó (y cómo cortarlo)
        </h1>

        {/* Subtitle */}
        <p className="hero-fade-3 text-[12px] text-brand-muted leading-snug" data-id="element-125">
          Protocolo pH‑ZERO: guía práctica para romper el ciclo con
          alimentación, fases claras y herramientas para que no vuelva.
        </p>

        {/* Product Image */}
        <a href="#compra" className="hero-fade-4 block w-full max-w-[252px] mx-auto -my-[5.5rem]" data-id="element-126">
          <img src="https://cdn.magicpatterns.com/uploads/nG8KNgtbHMDByMSEq3AHZN/IMG_7954.png" alt="Método pH-ZERO" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-127" />
        </a>

        {/* Method Content — 3 compact items */}
        <div className="hero-fade-5 w-full flex flex-col gap-1" data-id="element-128">
          <div className="flex items-start gap-2 bg-white/[0.04] rounded-lg px-2.5 py-1.5 text-left" data-id="element-129">
            <ShieldIcon size={15} className="text-brand-magenta flex-shrink-0 mt-0.5" data-id="element-130" />
            <p className="text-[11px] text-brand-muted leading-snug" data-id="element-131">
              <strong className="text-white/90" data-id="element-132">Guía paso a paso:</strong> Cortá
              la recurrencia de raíz con el método de desprogramación biológica.
            </p>
          </div>
          <div className="flex items-start gap-2 bg-white/[0.04] rounded-lg px-2.5 py-1.5 text-left" data-id="element-133">
            <LeafIcon size={15} className="text-brand-magenta flex-shrink-0 mt-0.5" data-id="element-134" />
            <p className="text-[11px] text-brand-muted leading-snug" data-id="element-135">
              <strong className="text-white/90" data-id="element-136">Alimentación + Listas:</strong>{' '}
              Bajá inflamación y ardor sin adivinar qué comer. Listas de súper
              incluidas.
            </p>
          </div>
          <div className="flex items-start gap-2 bg-white/[0.04] rounded-lg px-2.5 py-1.5 text-left" data-id="element-137">
            <HeartIcon size={15} className="text-brand-magenta flex-shrink-0 mt-0.5" data-id="element-138" />
            <p className="text-[11px] text-brand-muted leading-snug" data-id="element-139">
              <strong className="text-white/90" data-id="element-140">Hábitos y Prevención:</strong>{' '}
              Higiene íntima, suplementación y señales de alerta para resultados
              permanentes.
            </p>
          </div>
        </div>

        {/* CTA Button */}
        <a href="#compra" onClick={() => trackFbEvent('InitiateCheckout', {
        content_name: 'Hero CTA',
        value: 19990,
        currency: 'ARS'
      })} className="hero-fade-6 w-full max-w-sm bg-brand-magenta hover:brightness-110 text-white font-bold text-[14px] rounded-xl py-2.5 px-6 text-center transition-all animate-pulse-slow shadow-lg shadow-brand-magenta/30" data-id="element-141">
          🔓 QUIERO ROMPER EL CICLO HOY
          <span className="block text-[11px] font-normal mt-0.5 opacity-90" data-id="element-142">
            $19.990 · Acceso Inmediato
          </span>
        </a>

        {/* Micro-copy */}
        <p className="hero-fade-7 text-[10px] text-brand-muted text-center" data-id="element-143">
          🔒 Pago seguro · 📲 Descarga instantánea · 🇦🇷 Hecho para Argentina
        </p>
      </div>
    </section>;
}